import { css, keyframes } from '@emotion/react';

export const formBaseStyles = css({
  position: 'relative',
  width: '100%',
  borderTop: `1px solid var(--fabric-color-neutral-20)`,
  padding: 'var(--fabric-number-n-4) var(--fabric-number-n-2) var(--fabric-number-n-2)',
  '&:hover .char-limit-tooltip, &:focus-within .char-limit-tooltip': { opacity: 1 },
});

export const flexContainerStyles = css({
  display: 'flex',
  width: '100%',
  alignItems: 'start',
  position: 'relative',
  flexGrow: 1,
});

export const textareaBaseStyles = css({
  border: 'none',
  outline: 'none',
  resize: 'none',
  width: '100%',
  fontSize: 'var(--fabric-typography-body-md-font-size)',
  lineHeight: 'var(--fabric-typography-body-md-line-height)',
  color: 'var(--fabric-color-neutral-70)',
  flexGrow: 1,
  position: 'relative',
  backgroundColor: 'transparent',
  padding: 0,
});

export const textareaDisabledBgStyles = css({
  backgroundColor: 'var(--fabric-color-neutral-00)',
});

export const charLimitTooltipStyles = css({
  position: 'absolute',
  top: 'var(--fabric-number-n-1)',
  right: 0,
  transform: 'translateY(-100%)',
  fontSize: 'var(--fabric-typography-body-xs-font-size)',
  padding: 'var(--fabric-number-n-1) var(--fabric-number-n-2)',
  fontWeight: 'var(--fabric-font-weight-regular)',
  backgroundColor: 'var(--fabric-color-neutral-90)',
  color: 'var(--fabric-color-neutral-00)',
  borderRadius: 'var(--fabric-radius-sm)',
  whiteSpace: 'nowrap',
  pointerEvents: 'none',
  opacity: 0,
  transition: 'opacity 150ms ease-in-out',
});

export const bottomActionsBaseStyles = css({
  display: 'flex',
  alignItems: 'center',
  paddingTop: 'var(--fabric-number-n-2)',
});

export const signatureRowStyles = css({
  minHeight: 'var(--fabric-number-n-6)',
  display: 'flex',
  alignItems: 'center',
});

export const dropzoneOverlayStyles = css({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  padding: 'var(--fabric-number-n-2)',
  backgroundColor: 'var(--fabric-color-neutral-00)',
});

export const dropzoneInnerStyles = css({
  height: '100%',
  borderRadius: 'var(--fabric-radius-sm)',
  border: `1px solid var(--fabric-color-neutral-20)`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 'var(--fabric-number-n-2)',
});

export const dropzoneInputStyles = css({ display: 'none' });

export const textareaWrapperStyles = css({
  position: 'relative',
  flexGrow: 1,
  display: 'flex',
  isolation: 'isolate',
});

export const wiggleAnimation = keyframes({
  '0%, 100%': { transform: 'translateX(var(--fabric-number-n-0))' },
  '20%': { transform: 'translateX(var(--fabric-number-n-2-neg))' },
  '50%': { transform: 'translateX(var(--fabric-number-n-2))' },
  '80%': { transform: 'translateX(var(--fabric-number-n-1-neg))' },
});

export const wiggleStyles = css({
  animation: `${wiggleAnimation} 400ms ease-in-out`,
});

// Groups the inline error notification and the send button side-by-side
export const sendButtonGroupStyles = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--fabric-number-n-2-5)',
  padding: '0 var(--fabric-number-n-2)',
  flexShrink: 0,
});

export const styles = {
  formBaseStyles,
  flexContainerStyles,
  textareaBaseStyles,
  textareaDisabledBgStyles,
  charLimitTooltipStyles,
  bottomActionsBaseStyles,
  signatureRowStyles,
  dropzoneOverlayStyles,
  dropzoneInnerStyles,
  dropzoneInputStyles,
  textareaWrapperStyles,
  wiggleAnimation,
  wiggleStyles,
  sendButtonGroupStyles,
};
